<template>
	<div id="app" class="app--layout d-flex flex-column">
		<nk-review-mode-bar />
		<router-view v-if="appLoaded" v-slot="{ Component, route }">
			<transition name="auth-page-fade" mode="out-in">
				<component :is="Component" />
			</transition>
		</router-view>
		<div class="center-box" v-else>
			<div v-if="!error" class="text-center">
				<img src="../assets/loading.gif" alt="">
				<div class="text">{{ $t('intro.loading') }}</div>
			</div>
			<div class="d-flex align-items-center flex-column" v-else>
				<nk-lottie :options="lottie" />
				<div class="text">{{ $t('intro.loading-error') }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import PrepareEndpoints from '~/plugins/prepare-endpoints'
	import WindowsManager from '~/plugins/windows-manager'
	import { post } from '~/plugins/nikan-api'
	import { mapGetters } from 'vuex'

	export default {

		data() {
			return {
				error: false,
				appLoaded: false,
				nextPage: null,
				windowId: Date.now().toString(),
				lottie: {
					styles: {
						width: '65px',
						height: '65px',
					},
					defaultOptions: {
						animationData: null,
						loop: false,
					}
				},
			}
		},
		computed: {
			...mapGetters('useraccount', ['currentUserDetails']),
		},
		created() {
			PrepareEndpoints()
			let r = this.$route
			if (r.name === 'page') {
				this.nextPage = r.params.page
			}
		},
		async mounted() {
			// Load Lottie animation data
			if (this.error) {
				const errorAnimation = await import('~/assets/lottie/error.json')
				this.lottie.defaultOptions.animationData = errorAnimation.default
			}

			await WindowsManager.initWindowsManager(this.windowId)

			this.getInstallStatus()
				.then((result) => {
					return {
						lanuchRequired: !result.customerCodeExist,
						migrationRequired: !!result.migrationRequired,
						installed: !!result.coreIsInitialized,
						loggedIn: this.currentUserDetails.user != null,
					}
				})
				.then((result) => {
					const query = this.$route.query
					if (result.lanuchRequired) {
						this.$router.push({ name: 'launcher' })
					} else if (result.migrationRequired) {
						this.$router.push({ name: 'migration' })
					} else if (!result.installed) {
						this.$router.push({ name: 'install' })
					} else if (this.$route.name === 'recovery') {
						this.$router.push({ name: 'recovery', query: query })
					} else if (!result.loggedIn) {
						this.$router.push({ name: 'login', query: { next: this.nextPage } })
					} else if (this.nextPage != null) {
						this.$router.push({ name: 'page', params: { page: this.nextPage }, query })
					} else {
						this.$router.push({ name: 'home' })
					}
					this.defer(() => {
						// defer beacause prevent route and load app_layout apis
						this.appLoaded = true
					}, 500)
				})
				.catch((error) => {
					this.error = true
					console.error(error)
				})
		},
		methods: {
			getInstallStatus() {
				return new Promise((resolve, reject) => {
					if (!this.currentUserDetails.customerCode) { // if customerCode not exist launch required
						resolve({ customerCodeExist: false })
						return
					}
					if (this.$router.currentRoute._value.name === 'launcher') {
						resolve({ customerCodeExist: false }) // in launcher page must not call getStatus
						return
					}
					post('/api/v1.0/system/install/getStatus', null, null, { ignoreCommercialAccess: true })
						.then((result) => {
							result.data.customerCodeExist = true
							resolve(result.data)
						})
						.catch((error) => {
							reject(error)
						})
				})
			},
		},
	}
</script>

<style src="~/styles/intro.less" lang="less" scoped></style>